import $ from 'jquery';

Drupal.behaviors.header = {
  attach() {
    $('.hamburger-icon').on('click', () => {
      $('.header-menu-item-wrapper').toggleClass('display-header');
      $('button.ui-hamburger-02').toggleClass('header-active');
    });
    $('.defaultheader .mobile-search-btn').on('click', () => {
      if ($('.mobile-search-btn').hasClass('active')) {
        $('.mobile-search-btn').removeClass('active');
        $('.mobile-search-input').slideUp();
      } else {
        $('.mobile-search-btn').addClass('active');
        $('.mobile-search-input').slideDown();
      }
    });
  },
};

